export { default as PageReward } from "./page-reward.vue";
export { default as PageCreateReward } from "./page-create-reward.vue";
